var render = function () {
  var _vm$locationDetail,
    _vm$locationDetail2,
    _vm$locationDetail3,
    _vm$locationDetail4,
    _vm$locationDetail5,
    _vm$locationDetail6,
    _vm$locationDetail7,
    _vm$locationDetail8,
    _vm$locationDetail9,
    _vm$locationDetail10,
    _vm$locationDetail11,
    _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'SmartPin',
        to: {
          name: 'smart-pin'
        }
      }, {
        label: 'SmartPin Detail'
      }],
      "title": "Access Location"
    }
  }), _c('div', {
    staticClass: "flex justify-between items-center space-x-4"
  }, [_c('div', {
    staticClass: "bg-white shadow-sm rounded-lg h-80 p-4 w-full"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_vm._m(0), _c('div', {
    staticClass: "flex justify-center items-center space-x-4"
  }, [_c('Button', {
    staticClass: "flex font-bold justify-items-start items-center",
    class: ((_vm$locationDetail = _vm.locationDetail) === null || _vm$locationDetail === void 0 ? void 0 : _vm$locationDetail.status) === 9 ? 'border-blue-500 border-t border-l border-b border-r ' : 'border',
    attrs: {
      "color": "alternative",
      "size": "sm",
      "ovariant": "outlined"
    },
    on: {
      "click": function ($event) {
        return _vm.openModalConfirmationStatus();
      }
    }
  }, [_c('span', {
    staticClass: "text-xs",
    class: ((_vm$locationDetail2 = _vm.locationDetail) === null || _vm$locationDetail2 === void 0 ? void 0 : _vm$locationDetail2.status) === 9 ? 'text-blue-700' : 'text-gray-700'
  }, [_vm._v(" Set " + _vm._s(((_vm$locationDetail3 = _vm.locationDetail) === null || _vm$locationDetail3 === void 0 ? void 0 : _vm$locationDetail3.status) === 1 ? 'Inactive' : 'Active') + " Location ")])]), _c('Button', {
    staticClass: "flex border-red-500 border-t border-l border-r border-b justify-items-start items-center",
    attrs: {
      "ovariant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": _vm.openModalDeteleLocation
    }
  }, [_c('span', {
    staticClass: "text-xs text-red-500"
  }, [_vm._v("Delete Location")])])], 1)]), _c('div', {
    staticClass: "grid grid-cols-2 grid-rows-1 gap-4 mt-3"
  }, [_c('div', {
    staticClass: "flex-col"
  }, [_c('div', [_c('label', {
    staticClass: "text-sm text-gray-700 font-semibold"
  }, [_vm._v("Latitude Longitude")]), _c('p', {
    staticClass: "m-0 text-sm text-gray-500"
  }, [_vm._v(" " + _vm._s((_vm$locationDetail4 = _vm.locationDetail) === null || _vm$locationDetail4 === void 0 ? void 0 : _vm$locationDetail4.latitude) + "," + _vm._s((_vm$locationDetail5 = _vm.locationDetail) === null || _vm$locationDetail5 === void 0 ? void 0 : _vm$locationDetail5.longitude) + " "), _c('span', {
    staticClass: "text-blue-500 font-medium text-xs cursor-pointer ml-1 hover:text-blue-700 transition-colors",
    on: {
      "click": _vm.copyCoordinates
    }
  }, [_vm._v(" " + _vm._s(_vm.isCopied ? 'Copied' : 'Copy') + " ")])])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', {
    staticClass: "text-sm text-gray-700 font-semibold"
  }, [_vm._v("Radius")]), _c('p', {
    staticClass: "m-0 text-sm text-gray-500"
  }, [_vm._v(" " + _vm._s(Number((_vm$locationDetail6 = _vm.locationDetail) === null || _vm$locationDetail6 === void 0 ? void 0 : _vm$locationDetail6.allowed_radius).toLocaleString('id-ID')) + " meters ")])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', {
    staticClass: "text-sm text-gray-700 font-semibold"
  }, [_vm._v("Reading Progress")]), _c('p', {
    staticClass: "m-0 text-sm text-gray-500"
  }, [_vm._v(" " + _vm._s(((_vm$locationDetail7 = _vm.locationDetail) === null || _vm$locationDetail7 === void 0 ? void 0 : _vm$locationDetail7.reading_progress) === 100 ? 'Unlimited' : (((_vm$locationDetail8 = _vm.locationDetail) === null || _vm$locationDetail8 === void 0 ? void 0 : _vm$locationDetail8.reading_progress) || 0) + '%') + " "), _c('span', {
    staticClass: "text-blue-500 font-medium text-xs cursor-pointer ml-1 hover:text-blue-700 transition-colors",
    on: {
      "click": _vm.editReadingProgress
    }
  }, [_vm._v(" Edit ")])])])]), _c('div', [_c('div', {
    staticClass: "mt-0"
  }, [_c('label', {
    staticClass: "text-sm text-gray-700 font-semibold"
  }, [_vm._v("Terakhir Diubah")]), _c('p', {
    staticClass: "m-0 text-sm text-gray-500"
  }, [_vm._v(" " + _vm._s(_vm.formatDate((_vm$locationDetail9 = _vm.locationDetail) === null || _vm$locationDetail9 === void 0 ? void 0 : _vm$locationDetail9.modified_at)) + " ")])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', {
    staticClass: "text-sm text-gray-700 font-semibold"
  }, [_vm._v("Status")]), _c('p', {
    staticClass: "m-0 text-sm text-gray-500"
  }, [((_vm$locationDetail10 = _vm.locationDetail) === null || _vm$locationDetail10 === void 0 ? void 0 : _vm$locationDetail10.status) === 1 ? _c('span', {
    staticClass: "p-1 text-green-700 font-normal bg-green-100 rounded-lg text-xs"
  }, [_vm._v("Live")]) : _c('span', {
    staticClass: "p-1 text-gray-700 font-normal bg-gray-100 rounded-lg text-xs"
  }, [_vm._v("Inactive")])])])])])]), _c('div', {
    staticClass: "bg-white w-4/5 block rounded-lg shadow-sm p-4 justify-center items-center px-3 text-center h-80"
  }, [_c('div', {
    staticClass: "rounded-lg text-center flex justify-center"
  }, [_c('img', {
    staticClass: "w-48 border rounded-xl object-contain",
    attrs: {
      "src": (_vm$locationDetail11 = _vm.locationDetail) === null || _vm$locationDetail11 === void 0 ? void 0 : _vm$locationDetail11.qr_image,
      "alt": "QR Code"
    }
  })]), _c('div', {
    staticClass: "flex-col items-center justify-center space-y-3 mt-3"
  }, [_c('p', {
    staticClass: "text-sm mb-0 px-3 text-gray-500"
  }, [_vm._v("Users can only access the SmartPin collection from this area.")]), _c('div', {
    staticClass: "flex justify-center items-center space-x-4"
  }, [_c('Button', {
    staticClass: "flex border justify-items-start items-center",
    attrs: {
      "color": "alternative",
      "size": "sm",
      "ovariant": "outlined"
    },
    on: {
      "click": _vm.handleCopyUrl
    }
  }, [_c('span', {
    staticClass: "text-xs text-gray-700"
  }, [_c('i', {
    staticClass: "fa-solid fa-copy"
  }), _vm._v(" Copy URL ")])]), _c('Button', {
    staticClass: "flex border space-x-2 justify-center items-start",
    attrs: {
      "ovariant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": _vm.handleDownloadQR
    }
  }, [_c('div', {
    staticClass: "text-xs text-gray-700 flex justify-center items-center"
  }, [_c('i', {
    staticClass: "fa-solid fa-download mr-1"
  }), _vm._v(" Download QR")])])], 1)])])]), _c('SmartPinDetailContent'), _c('t-modal', {
    ref: "openModalReadingProgress"
  }, [_c('div', {
    staticClass: "flex-col justify-center text-left"
  }, [_c('label', {
    staticClass: "text-left font-semibold text-sm text-gray-800 tracking-normal"
  }, [_vm._v("Set Reading Progress Limits")]), _c('p', {
    staticClass: "text-gray-500 text-xs font-normal"
  }, [_vm._v("Choose whether users can read without limits or only up to a specified reading progress.")])]), _c('div', [_c('label', {
    staticClass: "flex items-center cursor-pointer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.limitType,
      expression: "limitType"
    }],
    staticClass: "w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500 cursor-pointer",
    attrs: {
      "type": "radio",
      "value": "none"
    },
    domProps: {
      "checked": _vm._q(_vm.limitType, "none")
    },
    on: {
      "input": _vm.handleRetrictions,
      "change": function ($event) {
        _vm.limitType = "none";
      }
    }
  }), _c('span', {
    staticClass: "ml-3 text-gray-700 text-xs font-medium"
  }, [_vm._v("No restrictions")])]), _c('label', {
    staticClass: "flex items-center cursor-pointer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.limitType,
      expression: "limitType"
    }],
    staticClass: "w-5 h-5 text-xs text-blue-600 border-gray-300 focus:ring-blue-500 cursor-pointer",
    attrs: {
      "type": "radio",
      "value": "limit"
    },
    domProps: {
      "checked": _vm._q(_vm.limitType, "limit")
    },
    on: {
      "change": function ($event) {
        _vm.limitType = "limit";
      }
    }
  }), _c('div', {
    staticClass: "ml-3 flex items-center space-x-3 text-gray-900 font-medium"
  }, [_c('span', {
    staticClass: "text-gray-700 text-xs"
  }, [_vm._v("Limit to")]), _c('div', {
    staticClass: "relative flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.progressLimit,
      expression: "progressLimit"
    }],
    staticClass: "w-16 text-xs border border-gray-200 bg-gray-50 rounded-lg py-1.5 pl-2 pr-7 text-center focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-50 transition-all",
    attrs: {
      "type": "number",
      "disabled": _vm.limitType !== 'limit',
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": _vm.progressLimit
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.progressLimit = $event.target.value;
      }, _vm.validateProgressLimit]
    }
  }), _c('span', {
    staticClass: "absolute right-3 text-gray-500 font-normal"
  }, [_vm._v("%")])]), _c('span', {
    staticClass: "text-gray-700 text-xs"
  }, [_vm._v("Reading Progress")])])])]), _c('div', {
    staticClass: "flex justify-start items-center space-x-3"
  }, [_c('Button', {
    class: {
      'opacity-50': !_vm.progressLimit
    },
    attrs: {
      "disabled": !_vm.progressLimit,
      "size": "sm"
    },
    on: {
      "click": _vm.handleReadingProgress
    }
  }, [_c('span', {
    staticClass: "text-xs"
  }, [_vm._v(" Save ")])]), _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": function () {
        _this.$refs.openModalReadingProgress.hide();
      }
    }
  }, [_c('span', {
    staticClass: "text-xs"
  }, [_vm._v(" Cancel ")])])], 1)]), _c('t-modal', {
    ref: "modalConfirmationStatus",
    on: {
      "before-close": _vm.onBeforeCloseModalStatus
    }
  }, [_c('div', {
    staticClass: "flex-col justify-center text-center p-0"
  }, [_c('label', {
    staticClass: "text-center font-semibold text-base text-gray-800 tracking-normal"
  }, [_vm._v(" " + _vm._s(_vm.locationDetail.status == 1 ? 'Deactivate' : 'Active') + " Location ")]), _vm.locationDetail.status == 9 ? _c('p', {
    staticClass: "text-gray-500 text-sm font-normal mt-0"
  }, [_vm._v(" Users within this location will be able to access onsite content after this location is activated. ")]) : _vm.locationDetail.status == 1 ? _c('p', {
    staticClass: "text-gray-500 text-sm font-normal mt-0"
  }, [_vm._v(" Users within this location will no longer be able to access onsite content after this location is deactivated. ")]) : _vm._e()]), _c('div', {
    staticClass: "flex justify-center items-center space-x-3 mt-4"
  }, [_vm.locationDetail.status == 9 ? _c('Button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.confirmStatusChange
    }
  }, [_vm._v(" Activate Location ")]) : _vm.locationDetail.status == 1 ? _c('Button', {
    staticClass: "bg-red-500 text-white",
    attrs: {
      "color": "red",
      "variant": "default",
      "size": "sm"
    },
    on: {
      "click": _vm.confirmStatusChange
    }
  }, [_vm._v(" Deactivate Location ")]) : _vm._e(), _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": _vm.cancelStatusChange
    }
  }, [_vm._v(" Cancel ")])], 1)]), _c('t-modal', {
    ref: "modalDeleteLocation"
  }, [_c('div', {
    staticClass: "flex-col justify-center text-center p-0"
  }, [_c('div', [_c('i', {
    staticClass: "fa-solid fa-triangle-exclamation text-yellow-500 text-2xl"
  })]), _c('label', {
    staticClass: "text-center font-semibold text-base text-gray-800 tracking-normal"
  }, [_vm._v(" Delete this location permanently? ")]), _c('p', {
    staticClass: "text-gray-500 text-sm font-normal mt-0"
  }, [_vm._v(" This action cannot be undone. The geofence tracking will stop immediately, the QR code will become invalid, and all curated content links for this location will be cleared. ")]), _c('div', {
    staticClass: "flex justify-center items-center space-x-3 mt-4"
  }, [_c('Button', {
    staticClass: "bg-red-500 text-white",
    attrs: {
      "size": "sm",
      "variant": "default",
      "color": "red"
    },
    on: {
      "click": function ($event) {
        return _vm.handleDeleteLocation();
      }
    }
  }, [_vm._v(" Yes, Delete Location ")]), _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": function () {
        _this.$refs.modalDeleteLocation.hide();
      }
    }
  }, [_vm._v(" Cancel ")])], 1)])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('label', {
    staticClass: "font-bold text-lg leading-5"
  }, [_vm._v("Detail")])]);
}]

export { render, staticRenderFns }